<template>
  <v-img
    :src="backgroundImage"
    width="330"
    height="600"
    style="position: relative;"
    class="mx-auto"
  >
    <div
      style="position: absolute; top: 0px; left: 0px;"
      class="ma-5 font-weight-bold"
    >
      Next events
    </div>
    <div
      style="overflow-y: scroll; overflow-x: hidden; height: 600px; width: 100%;"
    >
      <v-img
        src="@/assets/shadow.png"
        class="pt-12"
        width="330"
        height="auto"
        style="margin-top: 300px"
      >
        <div class="mb-3">
          <v-progress-circular
            v-if="loading"
            indeterminate
            width="5"
            size="30"
          ></v-progress-circular>
          <v-row v-for="event in listEvents" :key="event.id">
            <v-col cols="12" class="text-left ml-5">
              <span class="body-2 font-weight-bold">{{
                event.date | parseDateSlash
              }}</span>
              - <span class="body-2">{{ event.title }}</span>
            </v-col>
            <v-col
              cols="12"
              class="white my-0 mx-auto pa-0"
              style="height: 1px; max-width: 80%;"
            >
            </v-col>
          </v-row>
        </div>
      </v-img>
    </div>
  </v-img>
</template>
<script>
import SendRequestMixin from "../../mixins/SendRequestMixin";

export default {
  name: "NextEvents",
  mixins: [SendRequestMixin],
  data() {
    return {
      loading: false,
      events: [],
      backgroundImage: ""
    };
  },
  computed: {
    listEvents() {
      return this._.filter(this.events, function(n) {
        return Date.parse(n.date) > Date.now();
      }).reverse();
    }
  },
  methods: {
    loadEvents() {
      this.loading = true;
      const _vm = this;
      // TODO: Sort by events which have a date in the future
      this.sendRequest({
        endpoint: `/get/news?limit=100&order_by=id&relations=author,comments`,
        store_as: "events",
        list: true
      }).then(() => (_vm.loading = false));
    },
    changePhoto() {
      const _vm = this;

      setTimeout(() => {
        let images = ["/HZ_EVENT_1.jpg", "/HZ_EVENT_2.jpg", "/HZ_EVENT_3.jpg"];
        this.backgroundImage =
          window.location.origin +
          "/img/events" +
          images[Math.floor(Math.random() * 3)];
        _vm.changePhoto();
      }, 7000);
    }
  },
  mounted() {
    this.loadEvents();
    this.changePhoto();
  }
};
</script>
